export default __webpack_public_path__ + "static/media/add_white.1a0a9140.svg";